<template>
  <pbc-modal ref='modal' @close="close" title="Layers">
    <template #default="{}">
      <layers-edit :partutil='partutil'
                   :transforms-and-source='transformsAndSource'
                   :selections='selections'
                   :indirect-selections='indirectSelections'
                   @change='$emit("change", $event)'
                   @selections='$emit("selections", $event)' />
    </template>

    <template #controls="{}">
      <div class="mx-2 mb-2 pt-2 flex justify-center border-t border-solid border-grey-500">
        <pbc-button @click="done">
          <check class="mx-1"/>
          <span class="mr-2">Done</span>
        </pbc-button>
      </div>
    </template>
  </pbc-modal>
</template>
<script>
import Check from '@icons/Check.vue';
import LayersEdit from './LayersEdit.vue';
export default {
  props:{
    partutil:{
      type: Object,
      required: true
    },
    transformsAndSource:{
      type: Object,
      required: true
    },
    selections:{
      type: Object,
      required: true
    },
    indirectSelections:{
      type: Object,
      required: true
    }
  },
  methods:{
    close() {
      this.$emit("close");
    },
    done() {
      this.$emit("close");
    }
  },
  components: {
    LayersEdit,
    Check
  }
}
</script>
